// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map__UaOG-"};